export default {
  getEvents: state => state.events,
}
